import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import _ from 'lodash';

export default class CompanyVendorUsersDAO extends DAO {

  constructor(store) {
    super(store, 'company_vendor_users');
    this.unsetCompanyVendorUsers = this.unsetCompanyVendorUsers.bind(this);
    this.clearCompanyVendorUsers = this.clearCompanyVendorUsers.bind(this);
  }

  unsetCompanyVendorUsers(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearCompanyVendorUsers() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_company_vendor_users, null, this.unsetCompanyVendorUsers, this.clearCompanyVendorUsers, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/CompanyVendorUsersDAO.js